import { render, staticRenderFns } from "./OutingPanel.vue?vue&type=template&id=c126c3e4&scoped=true&"
import script from "./OutingPanel.vue?vue&type=script&lang=js&"
export * from "./OutingPanel.vue?vue&type=script&lang=js&"
import style0 from "./OutingPanel.vue?vue&type=style&index=0&id=c126c3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126c3e4",
  null
  
)

export default component.exports